// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__M8HA0sy0EP{flex-direction:row-reverse;justify-content:flex-end}`, "",{"version":3,"sources":["webpack://./src/assets/components/settings/components/sections/dixaMessenger/views/flow/components/nodeTypeSubflowReturn/modal/subflowReturnModal.module.scss"],"names":[],"mappings":"AAAA,qBACE,0BAAA,CACA,wBAAA","sourcesContent":[".wrapper {\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__M8HA0sy0EP`
};
export default ___CSS_LOADER_EXPORT___;
